import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, CheckCircle, Users, Award, ArrowRight, Shield } from 'lucide-react';

const PaymentHome = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-600 to-blue-800 text-white py-16 md:py-24">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Award className="h-4 w-4" />
            <span className="text-sm">Formation certifiante</span>
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
            Book Formation<br/>E-Commerce
          </h1>
          <p className="text-base sm:text-lg text-blue-100 max-w-2xl mx-auto mb-8">
            Maîtrisez les fondamentaux du e-commerce digital avec notre formation complète. Accès immédiat, contenu mis à jour régulièrement.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/payment/product"
              className="inline-flex items-center justify-center gap-2 bg-white text-blue-700 font-semibold px-8 py-3 rounded-lg hover:bg-blue-50 transition-colors"
            >
              Découvrir la formation
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 text-center mb-12">Ce que vous allez apprendre</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { icon: <BookOpen className="h-6 w-6" />, title: "Stratégies E-Commerce", desc: "Apprenez les meilleures stratégies pour lancer et développer votre boutique en ligne." },
              { icon: <Users className="h-6 w-6" />, title: "Marketing Digital", desc: "Maîtrisez les techniques de marketing pour attirer et fidéliser vos clients." },
              { icon: <Shield className="h-6 w-6" />, title: "Gestion & Logistique", desc: "Optimisez la gestion de votre stock, vos livraisons et votre service client." }
            ].map((feature, i) => (
              <div key={i} className="text-center p-6 rounded-xl border border-gray-100 hover:shadow-md transition-shadow">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-50 text-blue-600 rounded-lg mb-4">
                  {feature.icon}
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-gray-500">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-2xl mx-auto px-4 text-center">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Prêt à vous lancer ?</h2>
          <p className="text-gray-500 mb-8">{"Accédez à l\u2019intégralité de la formation pour seulement 59€. Paiement unique, accès à vie."}</p>
          <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200">
            <div className="text-4xl font-bold text-blue-600 mb-2">59€</div>
            <p className="text-sm text-gray-400 mb-6">Paiement unique — Accès immédiat</p>
            <Link
              to="/payment/product"
              className="inline-flex items-center justify-center gap-2 bg-blue-600 text-white font-semibold px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors w-full"
            >
              Voir les détails
              <ArrowRight className="h-4 w-4" />
            </Link>
            <div className="flex items-center justify-center gap-2 mt-4 text-xs text-gray-400">
              <Shield className="h-3 w-3" />
              <span>Paiement sécurisé par Stripe</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PaymentHome;
